import { useToasts } from '@/store/toasts';

/**
 * Non-blocking replacement for `window.confirm` (operator rule: NEVER block
 * the UI with a modal — a dialog over a live map is a flight-safety hazard).
 *
 * First call arms the action and raises a warning toast; a second call with
 * the same key inside the window confirms and returns true. Anything else
 * lets the arm expire silently.
 */
const ARM_WINDOW_MS = 8000;

const pending = new Map<string, { expires: number; toastId: string }>();

export function armConfirm(key: string, message: string): boolean {
  const now = Date.now();
  const p = pending.get(key);
  if (p && p.expires > now) {
    pending.delete(key);
    useToasts.getState().dismiss(p.toastId);
    return true;
  }
  const toastId = useToasts.getState().push({
    tone: 'warn',
    title: message,
    body: 'Repeat the action within 8 s to confirm.',
    durationMs: ARM_WINDOW_MS,
  });
  pending.set(key, { expires: now + ARM_WINDOW_MS, toastId });
  return false;
}
